/* flag.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._c71l53f4%7Bmax-height%3A75pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m91wug%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo1wug%7Boverflow-x%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8fhey%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._v5641hdc%7Btransition%3Agap%20.3s%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1jn0%7Bcolor%3Avar(--flag-icon-color)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zidpf%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1h6o%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1tke1tcg%7Bmin-height%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul91tcg%7Bmin-width%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1mok%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pbyni7l%7Bz-index%3A600%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16qs8sq4%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%23091e423f%2C0%200%201px%20%23091e424f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._v564z97a%7Btransition%3Abackground-color%20.2s%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m915vq%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo15vq%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rkofajl%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1i4qfg65%7Boverflow-wrap%3Aanywhere%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
import { type CSSProperties, type FC, useCallback, useEffect, useState } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import { cx } from '@atlaskit/css';
import noop from '@atlaskit/ds-lib/noop';
import Heading from '@atlaskit/heading';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { DEFAULT_APPEARANCE } from './constants';
import Actions from './flag-actions';
import { useFlagGroup } from './flag-group';
import { DismissButton, Expander } from './internal';
import { flagBackgroundColor, flagIconColor, flagIconGlyph, flagTextColor, flagTextColorToken } from './theme';
import type { FlagProps } from './types';
const styles = {
  overflowWrap: "_1i4qfg65",
  flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq",
  flagT26Shape: "_2rko1mok"
};
const CSS_VAR_ICON_COLOR = '--flag-icon-color';
const descriptionStyles = null;
const iconWrapperStyles = null;
const flagWrapperStyles = null;
const analyticsAttributes = {
  componentName: 'flag',
  packageName: (process.env._PACKAGE_NAME_ as string),
  packageVersion: (process.env._PACKAGE_VERSION_ as string)
};
const transitionStyles = null;

/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */
const Flag: FC<FlagProps> = props => {
  const {
    actions = [],
    appearance = DEFAULT_APPEARANCE,
    icon,
    title,
    description,
    linkComponent,
    onMouseOver,
    onFocus = noop,
    onMouseOut,
    onBlur = noop,
    onDismissed: onDismissedProp = noop,
    testId,
    id,
    analyticsContext,
    delayAnnouncement,
    headingLevel = 2
  } = props;
  const [isDelayToAnnounce, setIsDelayToAnnounce] = useState(false);
  const {
    onDismissed: onDismissedFromFlagGroup,
    isDismissAllowed
  } = useFlagGroup();
  const onDismissed = useCallback((id: string | number, analyticsEvent: UIAnalyticsEvent) => {
    onDismissedProp(id, analyticsEvent);
    onDismissedFromFlagGroup(id, analyticsEvent);
  }, [onDismissedProp, onDismissedFromFlagGroup]);
  const [isExpanded, setIsExpanded] = useState(false);
  const onDismissedAnalytics = usePlatformLeafEventHandler({
    fn: onDismissed,
    action: 'dismissed',
    analyticsData: analyticsContext,
    ...analyticsAttributes
  });
  const isBold = appearance !== DEFAULT_APPEARANCE;
  const toggleExpand = useCallback(() => {
    setIsExpanded(previous => !previous);
  }, []);
  const buttonActionCallback = useCallback(() => {
    if (isDismissAllowed) {
      onDismissedAnalytics(id);
    }
  }, [onDismissedAnalytics, id, isDismissAllowed]);
  useEffect(() => {
    // If buttons are removed as a prop, update isExpanded to be false
    if (isBold && isExpanded && !description && !actions.length) {
      setIsExpanded(false);
    }
  }, [actions.length, description, isBold, isExpanded]);
  useEffect(() => {
    if (!delayAnnouncement) {
      return;
    }
    setTimeout(() => {
      setIsDelayToAnnounce(true);
    }, delayAnnouncement);
  }, [delayAnnouncement]);
  const onFocusAnalytics = usePlatformLeafEventHandler({
    fn: onFocus,
    action: 'focused',
    analyticsData: analyticsContext,
    ...analyticsAttributes
  });
  const onBlurAnalytics = usePlatformLeafEventHandler({
    fn: onBlur,
    action: 'blurred',
    analyticsData: analyticsContext,
    ...analyticsAttributes
  });
  const autoDismissProps = {
    onMouseOver,
    onFocus: onFocusAnalytics,
    onMouseOut,
    onBlur: onBlurAnalytics
  };
  const textColor = flagTextColor[appearance];
  const iconColor = flagIconColor[appearance];
  const iconGlyph = flagIconGlyph[appearance];
  const isDismissable = isBold || isDismissAllowed;
  const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
  // when delayAnnouncement is available we will use a hidden content for announcement
  const delayedAnnouncement = delayAnnouncement ? <VisuallyHidden>
			{title}
			{description}
		</VisuallyHidden> : undefined;
  return <div role="alert" data-testid={testId} {...autoDismissProps} className={ax(["_1bsb1osq"])}>
			<Box padding="space.200" backgroundColor={flagBackgroundColor[appearance]} xcss={cx(styles.flag, fg('platform-dst-shape-theme-default') && styles.flagT26Shape)}>
				<Inline alignBlock="start" space="space.200">
					<div
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style={({
          [CSS_VAR_ICON_COLOR]: iconColor
        } as CSSProperties)} data-testid={testId && `${testId}-icon-container`} className={ax(["_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"])}>
						{icon || iconGlyph}
					</div>
					<span className={ax(["_v5641hdc _16jlkb7n"])}>
						<Stack space={shouldRenderGap ? 'space.100' : 'space.0'} // Gap exists even when not expanded due to Expander internals always being in the DOM
          >
							{/* if isDelayToAnnounce is true, we will use the hidden content for screen reader to announce */}
							{isDelayToAnnounce && delayedAnnouncement}
							<Inline alignBlock="stretch" space="space.100" spread="space-between">
								<Box paddingBlockStart="space.050" paddingBlockEnd="space.025" xcss={styles.overflowWrap}>
									<Heading as={`h${headingLevel}`} size="xsmall" color={textColor}>
										<span
                  /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ aria-hidden={isDelayToAnnounce}>
											{title}
										</span>
									</Heading>
								</Box>
								{isDismissable ? !(isBold && !description && !actions.length) && <DismissButton testId={testId} appearance={appearance} isBold={isBold} isExpanded={isExpanded} onClick={isBold ? toggleExpand : buttonActionCallback} /> : null}
							</Inline>
							{/* Normal appearance can't be expanded so isExpanded is always true */}
							<Expander isExpanded={!isBold || isExpanded} testId={testId}>
								{description && <div
              // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
              style={{
                color: flagTextColorToken[appearance]
              }} data-testid={testId && `${testId}-description`}
              /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ aria-hidden={isDelayToAnnounce} className={ax(["_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"])}>
										{description}
									</div>}
								<Actions actions={actions} appearance={appearance} linkComponent={linkComponent} testId={testId} />
							</Expander>
						</Stack>
					</span>
				</Inline>
			</Box>
		</div>;
};
export default Flag;